<div
  class="budget-type-icon"
  [class.status-ceg]="cegFlagEnabled"
  [ngClass]="status.toLowerCase()"
  [style.width.px]="size"
  [style.height.px]="size"
></div>
